module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rf-field rf-select",
    class: _vm.computedClass
  }, [_vm._t("default", [(_vm.label) ? _c('label', {
    staticClass: "rf-label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]), _vm._v(" "), (!_vm.options.length) ? _vm._t("fallback") : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rf-select-box"
  }, [_c('select', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validation),
      expression: "validation"
    }],
    ref: "input",
    class: {
      'rf-select-has-value': _vm.value !== null
    },
    attrs: {
      "disabled": _vm.disabled || !_vm.options.length,
      "tabindex": "0"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onChange]
    }
  }, 'select', {
    name: _vm.name,
    id: _vm.name
  }, false), [(!_vm.options.length) ? _c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("No options available")]) : _vm._e(), _vm._v(" "), (_vm.placeholder) ? _c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c("rf-option", {
      tag: "option",
      attrs: {
        "option": option,
        "disabled": option.disabled
      }
    })
  })], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-fast"
    }
  }, [(_vm.showInvalid) ? _c('icon', {
    key: "invalid",
    staticClass: "rf-icon rf-icon-invalid",
    attrs: {
      "name": "exclamation-triangle"
    }
  }) : (_vm.showValid) ? _c('icon', {
    key: "valid",
    staticClass: "rf-icon rf-icon-valid",
    attrs: {
      "name": "check"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('icon', {
    staticClass: "rf-icon rf-caret",
    attrs: {
      "name": "caret-down"
    }
  }), _vm._v(" "), (_vm.showInvalid) ? _c('rf-message', [_vm._v(_vm._s(_vm.errors.first(_vm.name)))]) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f85c171c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frontend/components/RfSelect.vue
// module id = 264
// module chunks = 0